export enum GeometryType {
  POINT = 'Point',
  MAKER = 'Marker',
  POLYGON = 'Polygon',
  CIRCLE = 'Circle',
  RECTANGLE = 'Rectangle',
  LINESTRING = 'LineString'
}
